import { Injectable, inject } from '@angular/core';
import { DfEventData, DfEventService } from '@df/core/service/df-event';
import { GtmDataService } from '@df/module-gtm/service/gtm-data.service';
import { GtmDlService } from '@df/module-gtm/service/gtm-dl.service';
import './gtm-event-view-cart';

@Injectable({
    providedIn: 'root'
})
export class GtmEventViewCartTrigger {
    /**
     * GTM service
     */
    private gtmService = inject(GtmDlService);

    /**
     * DF events service
     */
    private dfEventService = inject(DfEventService);

    /**
     * GTM basket service
     */
    private gtmDataService = inject(GtmDataService);

    /**
     * Setup event listener
     */
    constructor() {
        this.init();
    }

    /**
     * Setup event listener
     */
    private init() {
        this.dfEventService.success(event => {
            if (event.id === 'dfBasketView') {
                this.dispatch(event, event.data.context);
            }
        });
    }

    /**
     * Dispatch event
     */
    private async dispatch(trigger: DfEventData, context: string) {
        return this.gtmService.dispatch({
            event: 'view_cart',
            triggerContext: {
                trigger
            },
            event_data: {
                basket_page_type: context
            },
            ecommerce: await this.gtmDataService.getEventData(this.gtmDataService.getBasketItems(), this.gtmDataService.getBasketExtras())
        });
    }
}
